export default {
  areas: {
    "ui:widget": "hidden",
  },
  "ui:order": ["areas", "userType"],
};
